app
    .controller('CoachLiveAgreementCtrl', function ($http, loginService) {
        this.user = loginService.currentUser;

        this.bundleHours = [];

        const hourEnd = 8;

        for (let i = 0; i <= 8; i++) {
            if (i > 0) {
                this.bundleHours.push({
                    value: i,
                });
            }
            if (i !== hourEnd) {
                this.bundleHours.push({
                    value: i + 0.25
                });
                this.bundleHours.push({
                    value: i + 0.5
                });
                this.bundleHours.push({
                    value: i + 0.75
                });
            }
        }

        this.save = () => {
            $http.post('/coach/private-service', this.service)
                .then((response) => {
                   this.close({$value: response.data});
                });
        };

        this.cancel = () => {
            this.dismiss();
        };

        this.$onInit = () => {
            this.service = {currency: 'USD', price: 0, bundledHours: 1, serviceType: 'live'};
        };
    })
    .component('coachLiveAgreement', {
        template: `
        <div>
            <div class="modal-header">
                <h1 style="font-size: 24px; font-family: 'goboldregular', Impact, sans-serif;margin: 10px auto; text-align: center;">
                    <chat-icon type="video" width="20" height="20"></chat-icon>
                    LIVE WORKOUT AGREEMENT
                </h1>
                <button class="btn btn-close" ng-click="$ctrl.cancel()">
                    <chat-icon type="cross" width="15" />
                </button>
            </div>

            <div style="display: flex; justify-content: center;" class="mb-4">
                <div style="display: flex; align-items: center;">
                    With
                </div>
                <div style="display: flex">
                    <img ng-src="{{ $ctrl.resolve.client.picture }}" style="width: 55px; height: 55px;margin: 0 20px;" />
                    <div style="display: flex; flex-direction: column;">
                        <h3>{{ $ctrl.resolve.client.displayName }}</h3>
                        <span>LEFT {{ $ctrl.resolve.client.minutes || 0}} min</span>
                    </div>
                </div>
            </div>
            <div class="text-center mt-4" ng-if="$ctrl.resolve.client.minutes">
                <button class="btn btn-green" ng-click="$ctrl.close()">
                    <chat-icon type="video" width="16" height="16"></chat-icon>
                    USE TIME LEFT
                </button>
            </div>
            <hr class="mt-4" style="width: 90%; border-color: #1D1D1B" />
            <div class="container">
                <h2 style="text-align: center; font-family: 'goboldregular', Impact, sans-serif; font-size: 20px; margin: 20px auto;">ADD MORE TIME</h2>
                <form name="form" ng-submit="form.$valid && $ctrl.save()">
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="">{{ 'modal.liveWorkout.label.bundleHour' | translate }}</label>
                        <select class="form-control custom-select" ng-model="$ctrl.service.bundledHours">
                            <option ng-value="hour.value" ng-repeat="hour in $ctrl.bundleHours">{{hour.value | timed}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-8">
                      <label for="inputPassword4">{{'modal.liveWorkout.label.bundlePrice'  | translate}}</label>
                      <input type="text" class="form-control" readonly value="{{ $ctrl.service.bundledHours * $ctrl.service.price }} {{$ctrl.service.currency}}" />
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-8">
                        <label for="">{{ 'modal.liveWorkout.label.priceProgram' | translate}}</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="number" class="form-control" ng-model="$ctrl.service.price">
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="inputPassword4">{{ 'modal.liveWorkout.label.currency' | translate}}</label>
                        <select type="password" class="form-control custom-select" ng-model="$ctrl.service.currency">
                          <option value="USD" selected> USD </option>
                          <option value="CAD"> CAD </option>
                        </select>
                    </div>
                </div>
                <div class="form-group text-center  mt-3 mb-4">
                    <button type="submit" class="btn btn-black">
                        SEND PROPOSITION
                    </button>
                </div>
                </form>
            </div>
        </div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'CoachLiveAgreementCtrl'
    });
